export const DASHBOARD = "/dashboard";
export const USER_MANAGEMENT = "/user-management";
export const OPERATOR_MANAGEMENT = "/operator-management";
export const USERS_LOG = "/users-log";
export const TRANSFER_LOG = "/transfer-log"
export const GROUP_MANAGEMENT = "/group-management";
/** Set to true to show "Gestione dei gruppi" in the sidebar and allow access to the route. */
export const SHOW_GROUP_MANAGEMENT = false;
export const CONFIGURATION_MANAGEMENT = "/configuration-management";
export const SECURITY_EVENTS_LOG = "/security-events-log";
export const GDPR_ERASURE_LOG = "/gdpr-erasure-log";
export const VAULT_TRANSACTIONS = "/vault-transactions";
export const FORENSIC_ANALYSIS = "/forensic-analysis";
export const CERTIFICATE_VERIFY = "/certificate-verify";